import {Injectable, OnDestroy} from '@angular/core';
import {Actions, createEffect, ofType} from '@ngrx/effects';
import {EMPTY, of, Subject, switchMap} from 'rxjs';
import {catchError, map, takeUntil, withLatestFrom} from 'rxjs/operators';
import {SportEventsClient} from "../../client/sport_events";

import {
  callSportEvents,
  successSportEvent,
  failSportEvent,
  partialSpUpdate
} from "./sport-events.actions";
import {PoolScope} from "../pool/pool.models";
import SportEvent = PoolScope.SportEvent;
import {selectPools} from "../pool/pool.selectors";
import {selectConfiguration} from "../configuration/configuration.selectors";
import {Store} from "@ngrx/store";
import {AppState} from "../core.state";
import {setWebsocketEvent} from '../coreWebsockets/coreWebsockets.actions';
import {ws} from './sport-events.reducer';
import {selectSportEventList} from "./sport-events.selector";

@Injectable()
export class SportEventsEffects implements OnDestroy{
  private readonly destroy$ = new Subject<void>();

  constructor(
    private actions$: Actions,
    private sportEventsClient: SportEventsClient,
    private store: Store<AppState>
  ) {
  }

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }

  callSportEvents$ = createEffect(() => {
      return this.actions$.pipe(
        ofType(callSportEvents),
        takeUntil(this.destroy$),
        switchMap((propVal) => {
          return this.sportEventsClient.get(propVal.id)
            .pipe(
              map((data: SportEvent) => {
                return successSportEvent({sport_event: data});
              }),
              catchError(error => {
                return of(failSportEvent({error: error}))
              })
            )
        }))
  }, {dispatch: true});

///// LIVE UPDATE
  setWebsocketEvent = createEffect(() => {
    return this.actions$.pipe(
      ofType(setWebsocketEvent),
      withLatestFrom(this.store.select(selectSportEventList), this.store.select(selectConfiguration), this.store.select(selectPools)),
      switchMap(([propVal, sportEventState, configuration, poolsState]) => {
        if (!configuration.coreSettings) return EMPTY;

        if (poolsState.currentPool && (poolsState.currentPool.type_code !== 'FANTASY_MVP' && poolsState.currentPool.sport_code !== 'FANTASY_GAMES')) {
          return EMPTY;
        }

        if (ws.RELOAD_EVENTS.includes(propVal.event)) {
          //
        }

        return of(partialSpUpdate({
          data: propVal.data,
          event: propVal.event
        }))
      })
    )
  }, {dispatch: true})
}
